import { getUrlParams } from "@/utils/utils";
import { Box, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Transactions from "./components/TransactionsV2";

const StyledBox = styled(Box)(({theme}) => ({
  padding: '0 16px',
}));

function CardTransList() {
  const {t} = useTranslation();

  const cardId = getUrlParams('cardId');
  const cardType = getUrlParams('cardType');

  return (
    <Box sx={{ width: '100%', flex: 1, height: '100%' }}>
      <Transactions cardId={cardId} cardType={cardType} pageable searchAll pageTitle={true} />
      {/* <StyledBox>
        <div className="list-wrapper">
          <Transactions pageable searchAll />
        </div>
      </StyledBox> */}
    </Box>
  );
}

export default CardTransList;
